import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
import { checkRole } from "../../components/recipe_page/recipe_page";
import { useStoreOpen } from "./storeOpen";
import "../marketplace/storefront/storefront.css";
import "./storeSwitch.css";

// Wraps /marketplace and the product pages. While the store is switched off everyone sees
// "the store is closed"; an admin still sees the store, under a note that says so, to check it
// before opening it again. /marketplace/order is left unwrapped: a card payment that comes back
// must still land.

const StoreClosed: React.FC = () => {
  useEffect(() => {
    document.title = "NΛSOS Store";
  }, []);
  return (
    <div className="sf-page">
      <div className="sf-state">
        <p className="sf-state-title">The store is closed</p>
        <p>
          It will open again soon. AOTD prints can still be pre-ordered on{" "}
          <Link to="/collectibles">collectibles</Link>.
        </p>
      </div>
    </div>
  );
};

export const StoreGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const open = useStoreOpen();
  const role = useAppSelector((state) => state.auth.role);
  if (open) return <>{children}</>;
  if (!checkRole(role ?? "", "admin")) return <StoreClosed />;
  return (
    <>
      <p className="ss-admin-note" role="status">
        The store is closed. Only admins see it; everyone else sees "the store is closed".{" "}
        <Link to="/admin/marketplace">Open it again</Link>
      </p>
      {children}
    </>
  );
};
